<script>
id = Math.random();
consoel.log(id);
modal_id = "modal-" + id;
</script>
<template>
  <b-card :title="title">
    <b-row>
      <div
        class="col-md-4 col-sm-6"
        v-for="param in params"
        v-bind:key="param.field"
      >
        <b-form-group :label="param.label">
          <NumberSeprator
            v-if="param.type == 'number'"
            v-model="param.value"
          ></NumberSeprator>
          <b-form-input
            v-if="param.type == 'text'"
            :type="param.type"
            v-model="param.value"
            :disabled="param.disabled"
          ></b-form-input>
          <date-picker
            clearable
            v-if="param.type == 'date-picker'"
            v-model="param.value"
          ></date-picker>
          <MDDropdown
            v-if="param.type == 'mddropdown'"
            v-bind:group="param.group"
            v-model="param.value"
          ></MDDropdown>
          <b-form-select
            v-if="param.type == 'select'"
            v-model="param.value"
            :options="param.options"
          ></b-form-select>
          <v-select-s
            v-if="param.type == 'vselect'"
            dir="rtl"
            :options="param.options"
            :reduce="(item) => item.value"
            label="text"
            :value="param.value"
            v-model="param.value"
            :autocomplete="'on'"
          ></v-select-s>
        </b-form-group>
      </div>
    </b-row>
    <b-row>
      <b-col v-if="params != null" cols="6" md="2" sm="6">
        <b-button
          @click="LoadData(1, false)"
          variant="success"
          block
          :class="isBusy ? 'spinner spinner-light spinner-right' : ''"
          >جستجو</b-button
        >
      </b-col>
      <b-col v-if="newUrl != null" cols="6" md="2" sm="6">
        <b-button class="ml-3" :href="'#/' + newUrl" variant="info"
          >جدید</b-button
        >
      </b-col>
      <b-col v-if="excelroute != null" cols="6" md="2" sm="6">
        <b-button
          :class="
            'ml-3 ' + (isBusyExcel ? 'spinner spinner-light spinner-right' : '')
          "
          variant="danger"
          class="ml-5"
          @click="exportExcel"
          >دریافت فایل اکسل</b-button
        >
      </b-col>
      <b-col cols="6" md="2" sm="6">
        <slot name="btn"></slot>
      </b-col>
    </b-row>
    <!-- <b-button
      @click="LoadData(1, false)"
      variant="success"
      v-if="params != null"
      :class="'ml-3 ' + (isBusy ? 'spinner spinner-light spinner-right' : '')"
      >جستجو</b-button
    >
    <b-button v-if="newUrl != null" :href="newUrl" variant="info"
      >جدید</b-button
    >

    <b-button
      v-if="excelroute != null"
      :class="
        'ml-3 ' + (isBusyExcel ? 'spinner spinner-light spinner-right' : '')
      "
      variant="danger"
      class="ml-5"
      @click="exportExcel"
      >دریافت فایل اکسل</b-button
    > -->
    <!-- <b-modal
      id="ssss"
      title="جستجو"
      @ok.prevent=""
      ok-title="جستجو"
      cancel-title="انصراف"
      ok-variant="success"
      v-model="modalShow"
    >
    </b-modal> -->

    <!-- <table class="table table-striped">
      <thead>
        <tr>
          <th v-for="header in fields" v-bind:key="header.key">
            {{ header.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="rows in datas" v-bind:key="rows.id">
          <td v-for="header in fields" v-bind:key="header.key">
            {{ rows[header.key] }}
          </td>
        </tr>
      </tbody>
    </table> -->
    <div v-if="!dataLoaded" class="pt-5 pb-5">
      <b-skeleton-table
        :rows="5"
        :columns="4"
        :table-props="{ bordered: true, striped: true }"
      ></b-skeleton-table>
    </div>
    <div v-else>
      <b-table
        responsive
        :busy="isBusy"
        style="width: 100%"
        striped
        hover
        show-empty
        empty-text="آیتمی جهت نمایش وجود ندارد"
        :items="datas"
        :fields="
          fields.filter((element) => {
            return element.visible == null || element.visible == true;
          })
        "
      >
        <template v-slot:cell(btns)="row">
          <b-icon
            v-b-popover.hover.top="x.title"
            style="cursor: pointer"
            class="text-primary ml-2"
            :icon="x.icon"
            aria-hidden="true"
            v-for="x in btns"
            :key="x.icon"
            @click="x.handler(row.item)"
          ></b-icon>
        </template>
        <template v-slot:cell(details)="row">
          <div class="collect-link">
            <b-link
              v-if="detailUrl != '' && detailUrl != null"
              variant="success"
              :href="detailUrl + '/' + row.item.id"
              ><svg
                data-v-41be6633=""
                viewBox="0 0 16 16"
                width="1em"
                height="1em"
                focusable="false"
                role="img"
                aria-label="pencil"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi-pencil mx-auto b-icon bi"
              >
                <g data-v-41be6633="">
                  <path
                    d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5L13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175l-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
                  ></path>
                </g>
              </svg>
            </b-link>
            <b-link
              v-if="detailCallFun != '' && detailCallFun != null"
              @click="handle_function_call(row.item)"
              ><svg
                data-v-41be6633=""
                viewBox="0 0 16 16"
                width="1em"
                height="1em"
                focusable="false"
                role="img"
                aria-label="pencil"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi-pencil mx-auto b-icon bi"
              >
                <g data-v-41be6633="">
                  <path
                    d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5L13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175l-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
                  ></path>
                </g>
              </svg>
            </b-link>
            <b-link
              v-if="viewUrl != '' && viewUrl != null"
              variant="success"
              :href="viewUrl + '/' + row.item.id"
              ><svg
                viewBox="0 0 16 16"
                width="1em"
                height="1em"
                focusable="false"
                role="img"
                aria-label="eye"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi-eye mx-auto b-icon bi"
                data-v-41be6633=""
              >
                <g data-v-41be6633="">
                  <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                  ></path>
                  <path
                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                  ></path>
                </g>
              </svg>
            </b-link>
          </div>
        </template>
      </b-table>
    </div>
    <hr class="dashed" v-if="sumPrice" />
    <b-row align-h="end" v-if="sumPrice">
      <b-col sm="12" md="3">
        <label class="form-control"
          >مبلغ جمع شده: {{ sum_Price.toLocaleString() }} ریال</label
        >
      </b-col>
      <b-col v-if="back" sm="12" md="3">
        <b-button @click="$router.push('/goallinks')" block>بازگشت</b-button>
      </b-col>
    </b-row>
    <!-- <b-table striped hover :items="datas">
      <template v-for="field in fields" :slot="field" slot-scope="row">
        <span v-html="row.value"></span>
      </template>
    </b-table> -->
    <div class="row" v-if="page_count > 1">
      <b-button-group>
        <b-button @click="LoadData(1, false)"
          ><i class="flaticon2-next"></i
        ></b-button>
        <b-button
          v-for="page in pages"
          v-bind:key="page"
          @click="LoadData(page, false)"
          :variant="page == current_page ? 'success' : 'default'"
          >{{ page }}</b-button
        >
        <b-button @click="LoadData(page_count, false)"
          ><i class="flaticon2-back"></i
        ></b-button>
      </b-button-group>
       <b-input-group class="ml-3 w-150 mt-4 mt-md-0">
       <b-input-group-prepend>
      <b-button @click="LoadData(pageNumber, false)" variant="success">برو به صفحه</b-button>
    </b-input-group-prepend>
    <b-form-input :formatter="toEnglishNumbers" v-model="pageNumber"></b-form-input>
  </b-input-group>
    </div>
  </b-card>
</template>
<style>
.w-150{
  width: 150px;
}
.circle-dot {
  border: 1px solid;
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  text-align: center;
}

.collect-link a {
  display: inline-block;
  margin-right: 10px;
}
</style>
<script>
import httpHelper from "../helpers/httpHelper";
import MDDropdown from "../components/MDDropdown";
import vSelect from "vue-select";
import ReplaceNumber from "@/mixins/ReplaceNumber";
import NumberSeprator from "../components/numberSeprator";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import _ from "lodash";
import { GET_DATA_TABLE } from "@/core/services/store/getDataTable.module";
import moment from "jalali-moment";
import routesMap from '@/helpers/routesMap'
export default {
  name: "TableShowData",
  mixins: [ReplaceNumber],
  components: {
    MDDropdown,
    "v-select-s": vSelect,
    NumberSeprator,
  },
  props: [
    "visibility",
    "url",
    "title",
    "fields",
    "params",
    "detailUrl",
    "viewUrl",
    "newUrl",
    "detailCallFun",
    "detailCallFunType",
    "refreshData",
    "excelroute",
    "btns",
    "sumPrice",
    "back",
  ],
  data() {
    return {
      dataExcel: [],
      isBusyExcel: false,
      isBusy: true,
      dataLoaded: false,
      datas: [],
      pages: [],
      current_page: 0,
      page_count: 0,
      modalShow: false,
      sum_Price: "",
      pageNumber: null,
      routesMap
    };
  },
  watch: {
    url: function (newVal, oldVal) {
      if (newVal != null) {
        this.LoadData(1, false);
      }
    },
    refreshData: function (newVal, oldVal) {
      if (newVal != null) {
        this.LoadData(1, false);
      }
    },
    visibility(newVal, oldVal) {
      this.datas = null;
      this.dataLoaded = newVal;
    },
  },
  methods: {
    // transactionExportExcel(){
    //   httpHelper.getData(this.excelroute).then(res=>{

    //   })
    // },
    toEnglishNumbers(value) {
      const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
      return p2e(value) 
    },
    createPager(last_page, current_page) {
      this.pages = [];
      this.current_page = parseInt(current_page);
      this.pageNumber = current_page;
      var startPageer = this.current_page > 5 ? this.current_page - 4 : 0;
      var endPageer = last_page > 5 ? this.current_page + 3 : last_page;
      this.page_count = last_page;
      if (this.current_page + 3 > this.page_count) {
        endPageer = this.page_count;
      }
      for (let i = startPageer; i < endPageer; i++) {
        this.pages.push(i + 1);
      }
    },
    handle_function_call(item) {
      this.$emit("handle_function_call", item, this.detailCallFunType);
      //this.$parent[this.detailCallFun](item_id);
    },
    LoadData(page, isForExcel = false) {
      if (this.url == "") {
        return;
      }

      this.dataLoaded = false;
      var filter = "&";
      if (this.params) {
        this.params.forEach((element) => {
          element.value = this.fixNumbers(element.value);
          if (element.value != null && element.value != "") {
            filter += element.field + "=" + element.value + "&";
          }
        });
        filter = filter.slice(0, -1);
      }
      this.isBusy = true;
      let getDataUrl = this.url;
      if (getDataUrl.indexOf("?") == -1) {
        getDataUrl += "?";
      } else {
        getDataUrl += "&";
      }
      if (isForExcel) {
        filter += "&isForExcel=true";

        getDataUrl += "page=" + page + filter;
        httpHelper.getData(getDataUrl).then((res) => {
          var link = document.createElement("a");
          link.download = "name";
          link.href = routesMap.download + res;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.isBusy = false;
        });
        return;
      }

      getDataUrl += "page=" + page + filter;

      httpHelper.getData(getDataUrl).then((res) => {
        this.dataLoaded = true;
        if (this.sumPrice) {
          if (res.result.sumPrice) {
            this.sum_Price = res.result.sumPrice;
          } else {
            let sum = _.sumBy(res.result.data, function (o) {
              return o.amount;
            });
            this.sum_Price = sum;
          }
        }
        this.isBusy = false;
        if (!isForExcel) {
          this.$store.dispatch(GET_DATA_TABLE, res.result);
          this.datas = res.result.data;

          this.modalShow = false;
          this.createPager(res.result.last_page, res.result.current_page);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    exportExcel() {
      this.isBusyExcel = true;
      var filter = "&";
      if (this.params) {
        this.params.forEach((element) => {
          element.value = this.fixNumbers(element.value);
          if (element.value != null && element.value != "") {
            filter += element.field + "=" + element.value + "&";
          }
        });
        filter = filter.slice(0, -1);
      }

      let getDataUrl = this.url;
      if (getDataUrl.indexOf("?") == -1) {
        getDataUrl += "?";
      } else {
        getDataUrl += "&";
      }

      filter += "&isForExcel=true";
      getDataUrl += filter;

      httpHelper.getData(getDataUrl).then((res) => {
        this.isBusyExcel = false;
        if (res.result.excel.length != 0) {
          this.dataExcel = res.result.excel;
          this.dataExcel = this.HotfixForExcelDate(
            this.dataExcel,
            res.result.columns
          );
          saveExcel({
            data: this.dataExcel,
            fileName: "myFile",
            columns: res.result.columns,
          });
        } else {
          this.$makeToast(
            "danger",
            "هشدار",
            "اطلاعاتی برای ساخت فایل اکسل وجود ندارد.",
            5000
          );
        }
      });
    },
    HotfixForExcelDate(dataExcel, columns) {
      for (let i = 0; i < columns.length; i++) {
        const element = columns[i];
        if (element.convert_type && element.convert_type == "datetime") {
          for (let j = 0; j < dataExcel.length; j++) {
            try {
              dataExcel[j][element.field] = moment(
                dataExcel[j][element.field],
                "YYYY/MM/DDTHH:mm:ss"
              ).format("jYYYY/jMM/jDD HH:mm:ss");
            } catch (error) {}
          }
        }
      }
      return dataExcel;
    },
  },
  mounted() {
    this.LoadData(1, false);
  },
};
</script>
